import React, { useState } from "react";
import GlobalModalComponent from "../../../../shared/globalModal/GlobalModalComponent";
import logo from "../../../../../assets/images/site-logo/Logo.png";
import CloseIcon from "../../../../../assets/images/pages/login/CloseButton.svg";
import styles from "./LoginModal.module.scss";
import InputComponent from "../../../../shared/input/InputComponent";
import MainButton from "../../../../shared/button/MainButton";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsForgetPassword,
  setIsLogin,
  setIsRegister,
  setIsUserStatus,
} from "../../../../../redux/Slices/userSlice";
import { Link, useNavigate } from "react-router-dom";
import { userLogin } from "../../../../../services/auth.service";
import { setCookie } from "../../../../../utils/utils";
import { AppDispatch, RootState } from "../../../../../redux/store";
import TitleUpdater from "../../../../shared/title/TitleUpdater";
import { fetchUser } from "../../../../../redux/Slices/userProfile";
const LoginModal = () => {
  const dispach = useDispatch();
  const [isModal, setIsModal] = useState(false);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data } = useSelector((state: RootState) => state.translationData);

  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    if (e.target instanceof HTMLSelectElement) {
      setFormValues((prevValues) => ({
        ...prevValues,
        countryCode: value,
      }));
    } else {
      setFormValues((prevValues) => ({
        ...prevValues,
        [name]: value,
      }));
    }
  };
  const LoginNavigation = () => {
    dispach(setIsUserStatus(true));
    dispach(setIsLogin(false));
  };
  const LoginClose = () => {
    dispach(setIsRegister(false));
    dispach(setIsLogin(true));
  };
  const ForgetPassword = () => {
    dispach(setIsForgetPassword(true));
    dispach(setIsLogin(false));
  };
  const dispatch = useDispatch<AppDispatch>();
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setIsSubmitting(true);

    const payload = {
      email: formValues.email,
      password: formValues.password,
    };

    try {
      const response = await userLogin(payload);
      const token = response?.data?.token;
      const message = response?.data?.message;
      if (response.status === 200 && token) {
        setCookie("ColibriToken", token, 14);
        setErrMessage("");
        await dispatch(fetchUser());
        navigate("/account/my-foriegn-locations");
      }
      if (!token) {
        navigate("/login");
        setErrMessage(message);
      }
    } catch (error: any) {
      const message = error?.message;
      setErrMessage(message);
    } finally {
      setIsLoading(false);
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <TitleUpdater
        title={
          data?.colibri && data?.auth_referal_login
            ? `${data?.colibri} | ${data?.auth_referal_login}`
            : "Colibri"
        }
      />
      <GlobalModalComponent isOpen={true} onClose={() => setIsModal(!isModal)}>
        <div className={styles.loginModal}>
          <div className={styles.headerLogin}>
            <Link to={"/"} onClick={LoginClose} className={styles.closeButton}>
              <img
                className={styles.closeIcon}
                src={CloseIcon}
                alt="Close Icon"
                onClick={LoginClose}
              />
            </Link>
          </div>
          <div className={styles.modalContainer}>
            <div className={styles.logo}>
              <img src={logo} alt="colibri" />
            </div>
            <h3 className={styles.loginTitle}>{data?.auth_common_welcome}</h3>
            {errMessage ? <p className={styles.err_msg}>{errMessage}</p> : ""}
            <form
              className={styles.inputContainer}
              onSubmit={(e) => handleSubmit(e)}
            >
              <InputComponent
                label={data?.email}
                type="text"
                name="email"
                placeholder={data?.email}
                isPassword={false}
                value={formValues.email}
                onChange={handleInputChange}
              />
              <InputComponent
                label={data?.auth_referal_password}
                type="password"
                name="password"
                placeholder={data?.auth_referal_password}
                isPassword={true}
                isShowPassword={isShowPassword}
                toggleShowPassword={() => setIsShowPassword(!isShowPassword)}
                value={formValues.password}
                onChange={handleInputChange}
              />
              <p className={styles.forgetPassword} onClick={ForgetPassword}>
                {data?.auth_common_forgot_password}
              </p>
              <MainButton
                text={data?.auth_referal_login}
                isLoading={isLoading}
                disabled={
                  isLoading ||
                  formValues.email === "" ||
                  formValues.password === "" ||
                  isSubmitting
                }
                type="submit"
                className={styles.buttonLogin}
              />
              <div className={styles.footerLogin}>
                <p className={styles.noProfileText}>
                  {data?.auth_common_no_account}
                </p>
                <p className={styles.registerText} onClick={LoginNavigation}>
                  {data?.login_registration}
                </p>
              </div>
            </form>
          </div>
        </div>
      </GlobalModalComponent>
    </>
  );
};

export default LoginModal;
